import React from 'react';
import TileContext from './TileContext';

export default function useTile() {
  return React.useContext(TileContext);
}
